import { Link, Outlet } from "react-router-dom";
import { BUSINESS } from "../config";

export default function Layout() {
  return (
    <>
      <header className="header">
        <div className="shell nav">
          <Link className="brand" to="/" data-testid="nav-brand">
            TAILOR <span>INC.</span>
            <small>ESTABLISHED 2008</small>
          </Link>
          <nav aria-label="Main navigation">
            <Link to="/" data-testid="nav-home">Home</Link>
            <Link to="/pricing" data-testid="nav-pricing">Alteration Prices</Link>
            <Link to="/subscription" data-testid="nav-subscription">Preferred Subscription</Link>
            <Link to="/booking" data-testid="nav-booking">Book a Fitting</Link>
          </nav>
          <Link to="/booking" className="nav-cta" data-testid="nav-book-cta">Book Now</Link>
        </div>
      </header>
      <Outlet />
      <footer className="footer">
        <div className="shell footgrid">
          <div>
            <div className="brand">TAILOR <span>INC.</span></div>
            <p>Exceptional Tailoring. Delivered to You.</p>
            <p>Blue Springs · Greater Kansas City</p>
          </div>
          <div>
            <strong>Explore</strong>
            <Link to="/booking">Book a fitting</Link>
            <Link to="/pricing">Alteration pricing</Link>
            <Link to="/subscription">Preferred Subscription</Link>
            <Link to="/gallery" data-testid="footer-gallery">Gallery</Link>
            <Link to="/policies">Policies & disclosures</Link>
          </div>
          <div>
            <strong>Get in touch</strong>
            <a href={`tel:${BUSINESS.phone.replace(/\D/g, "")}`} data-testid="footer-phone">{BUSINESS.phone}</a>
            <a href={BUSINESS.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram">Instagram {BUSINESS.instagramHandle}</a>
            <p>By appointment only · Mobile service</p>
          </div>
        </div>
        <div className="shell copyright">© {new Date().getFullYear()} Tailor Inc. · Established 2008 · All rights reserved.</div>
      </footer>
    </>
  );
}
